import type { Type } from '@angular/core';
import { ContentChild, Directive, inject } from '@angular/core';

import { TemplateResolver } from '../../utils/template-resolver';
import { FooterDefaultComponent } from './footer-default.component';
import { Select2FooterDirective } from './footer.directive';

@Directive({
  standalone: true,
  selector: 'rt-select2-footer-resolver',
})
export class FooterResolverDirective extends TemplateResolver<
  Select2FooterDirective,
  { optional: true }
> {
  @ContentChild(Select2FooterDirective)
  public override contentDirective?: Select2FooterDirective;
  public override injectedComponent = <Type<FooterDefaultComponent>>(
    (<unknown>inject(FooterDefaultComponent, { optional: true }))
  );
  public override defaultComponent = null;
}
